import api from './api';

export const getElevatorsApi = params => {
  return api.get('/elevators', {params});
};

export const getAllElevatorsApi = params => {
  return api.get('/elevators/all', {params});
};
export const getInactiveElevatorsApi = params => {
  return api.get('/elevators/inactive', {params});
};

export const getElevatorByIdApi = id => {
  return api.get(`/elevators/${id}`);
};

export const getElevatorConfigurationApi = id => {
  return api.get(`/elevators/${id}/configure`);
};

export const getElevatorsByBuildingApi = (buildingId, params) => {
  return api.get(`/elevators/building/${buildingId}`, {params});
};

export const getElevatorsByEntranceApi = (entranceId, params) => {
  return api.get(`/elevators/entrance/${entranceId}`, {params});
};

export const addElevatorApi = params => {
  return api.post('/elevators', params);
};

export const editElevatorApi = params => {
  return api.put('/elevators', params);
};

export const configureElevatorApi = (
  id,
  params,
  sms_username,
  sms_password,
) => {
  const paramsToSend = {...params};
  if (sms_username && sms_password) {
    paramsToSend.sms_username = sms_username;
    paramsToSend.sms_password = sms_password;
  }
  return api.post(`/elevators/${id}/configure`, paramsToSend);
};

export const deleteElevatorApi = id => {
  return api.delete(`/elevators/${id}`);
};
